export default __webpack_public_path__ + "static/astraeus_bg-231c8d64dcd75f1f15a333215e02a3c0.jpg";